import React, { useState } from "react";
import { Form, Button, DatePicker } from "antd";
import { typeForDetailsProyect } from "../../../types/typeModalDetailsProject";
import { ContainerModal } from "../../container/ContainerModal";

const dateFormat = "YYYY/MM/DD";

export const FormFinishProject = ({ editFormForProjectDetails, closeModalDetails }) => {

	const [form] = Form.useForm();

	const [loading, setLoading] = useState(false);

	const finishForm = async (values) => {
		setLoading(true);
        await editFormForProjectDetails(typeForDetailsProyect.finishProjectDate, values.finishedAt.format(dateFormat));
        setLoading(false);
	};

	return (
		<div className="fixed top-0 left-0 w-full h-full z-50 bg-black bg-opacity-45 flex justify-center items-center">
			<ContainerModal
				title={"Concluir proyecto"}
				actionButton={() => {
					closeModalDetails();
				}}
				className={"w-[500px]"}
			>
				<Form form={form} onFinish={finishForm} className="flex flex-col gap-5 w-full">
					<div className="flex justify-center items-center">
						<p>¿Estás seguro de concluir el proyecto?</p>
					</div>
					<div className="flex  gap-4 items-center justify-center">
						<p>
							<span className="text-[#E4404B]">*</span>Fecha que se concluyó
						</p>
						<Form.Item
							name={"finishedAt"}
							className="h-[10px]"
							rules={[
								{
									required: true,
									message: "Necesita una fecha",
								},
							]}
						>
							<DatePicker format={dateFormat} size="small" />
						</Form.Item>
					</div>
					<div className="w-full h-[40px] overflow-hidden flex justify-center gap-4">
						<Button htmlType="button" onClick={closeModalDetails}>
							Cancelar
						</Button>
						<Button type="primary" htmlType="submit" className="bg-primaryTwo" loading={loading}>
							Aceptar
						</Button>
					</div>
				</Form>
			</ContainerModal>
		</div>
	);
};
